import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useRef } from "react";
import { Route, useLocation, useHistory } from "react-router-dom";
import GlobaleEventListener from "Uitls/GlobaleEventListener";

// import { Route } from "react-router-dom/cjs/react-router-dom.min";

// const KeyCloakPrivateRoute = ({
//   component: Component,
//   canAccessedBy,
//   role,
//   ...rest
// }) => {
//   const { initialized, keycloak } = useKeycloak();
//   const currentLocation = useLocation();
//   let init = false;
//   if (!initialized && !init) {
//     init = true;
//     return <div>Loading...</div>;
//   }

//   const hasAccess = () => {
//     // not having canAccessedBy as props, will be treated as a whitelisted route for all
//     if (!canAccessedBy) {
//       return true;
//     }
//     const userRoles = keycloak.realmAccess.roles; //window.localStorage.getItem("userRole") || "";

//     for (let i = 0; i < userRoles.length; i++) {
//       if (canAccessedBy.includes(userRoles[i])) {
//         return true;
//       }
//     }
//     return false;
//   };
//   const isLoggedIn = keycloak.authenticated && hasAccess();

//   // return isLoggedIn ? (
//   //   <Route
//   //     {...rest}
//   //     render={(props) => {
//   //       return <Component {...props} />;
//   //     }}
//   //   />
//   // ) : (
//   //   <Redirect to={{ pathname: "/", state: currentLocation || "" }} />
//   // );

//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         if (isLoggedIn) {
//           return (
//             <>
//               <GlobaleEventListener />
//               <Component {...props} />
//             </>
//           );
//         } else {
//           return (
//             <Redirect to={{ pathname: "/", state: currentLocation || "" }} />
//           );
//         }
//       }}
//     />
//   );
// };
const KeyCloakPrivateRoute = ({
  component: Component,
  canAccessedBy,
  role,
  ...rest
}) => {
  const { initialized, keycloak } = useKeycloak();
  const currentLocation = useLocation();
  const history = useHistory();
  const loadingShownRef = useRef(false);
  const loadingTimeoutRef = useRef();

  const shouldShowLoading = !initialized && !loadingShownRef.current;

  useEffect(() => {
    if (initialized) {
      clearTimeout(loadingTimeoutRef.current);
    }
    return () => clearTimeout(loadingTimeoutRef.current);
  }, [initialized]);

  const hasAccess = () => {
    if (!canAccessedBy) return true;
    const userRoles = keycloak.realmAccess?.roles || [];
    return userRoles.some((r) => canAccessedBy.includes(r));
  };

  const isLoggedIn = initialized && keycloak.authenticated && hasAccess();

  // Use an imperative redirect instead of <Redirect> component.
  // <Redirect> calls history.replace() inside componentDidUpdate, which fires
  // on every render — causing an infinite loop when onAuthLogout triggers a
  // state update inside KeycloakProvider while the component is still mounted.
  // useEffect only fires when isLoggedIn actually changes, breaking the cycle.
  useEffect(() => {
    if (initialized && !isLoggedIn && currentLocation.pathname !== "/") {
      history.replace({ pathname: "/", state: currentLocation });
    }
  }, [initialized, isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  if (shouldShowLoading) {
    loadingShownRef.current = true;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          backgroundColor: "white",
          zIndex: 99,
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoggedIn) {
          return (
            <>
              <GlobaleEventListener />
              <Component {...props} />
            </>
          );
        }
        return null;
      }}
    />
  );
};

export default KeyCloakPrivateRoute;
